import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"
import SystemsOverviewComponent from "../components/SystemOverviewComponent"

const SystemOverViewPage = () => {
    return (
        <>
            <HeaderComponent/>
            <div className="bg-gray-100">
            <SystemsOverviewComponent/>
            </div>
            <FooterComponent/>
        </>
    )
}

export default SystemOverViewPage